import config from "@core/config";

export const AZURE_ID_TOKEN_SCOPES = ["User.Read"];
export const AZURE_ACCESS_TOKEN_SCOPES = [
  `api://${config.PCA_CLIENT_ID}/api-gateway-access`,
];
export const AZURE_PCA_AUTHORITY = `${config.PCA_AUTHORITY}`;
export const storageKeys = {
  returnUrl: "RETURN_URL",
  sidebarCollaped: "CCAU_SIDEBAR_COLLAPSED",
  theme: "CCAU_THEME",
  mockLogin: "CCAU_MOCK_LOGIN",
  mockPassword: "CCAU_MOCK_PASSWORD",
} as const;

export const MAX_INT_32 = 2147483647;
